import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import notify from "../../../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import { createApplicationAction } from "../../../../../redux/actions/ApplicationAction";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { getCarByIdAction } from "../../../../../redux/actions/CarAction";

const Naqdi = () => {
  const [esal, setesal] = useState("");
  const [feedback, setfeedback] = useState("");
  const idcar = localStorage.getItem("id_car");
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const navegate = useNavigate();
  const dataa = useSelector((state) => state.CarReduser.GetcarbyId);

  useEffect(() => {
    dispatch(getCarByIdAction(idcar));
  }, [idcar]);

  const dispatch = useDispatch();
  const handlesubmit = async (e) => {
    e.preventDefault();
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 1);
    formData.append("car_id", idcar);
    formData.append("comment", feedback);
    formData.append("payment_type", "cash");
    formData.append("payment_receipt", esal);
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setesal("");
    setfeedback("");

    setisPress(false);
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        }
       else if (res.status !== 200 || res.status !== 201) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div>
      <h3 className="text-center mb-2">
        توجه إلى مقر الشركة وقم بدفع 50% من سعر السيارة و هو{" "}
        {dataa && dataa.price / 2} جنية
      </h3>
      <h4 className="text-center" style={{ color: "red" }}>
        في حالة التعامل بالعملات الأجنبية يتم التعامل بسعر الصرف في توقيت
        الأستلام
      </h4>
      <h5 className="text-center">
        ويمكن الدفع في وقت اخر بعد الضغط على استكمال الطلب
      </h5>
      <div className="attachment text-center">
        <div className="inp">
          <TextField
            label="قم برفع الإيصال"
            focused
            type="file"
            onChange={(e) => {
              setesal(e.target.files[0]);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp">
          <TextField
            label="ملاحظات"
            type="text"
            value={feedback}
            onChange={(e) => {
              setfeedback(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        {isPress && loading ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            {" "}
            استكمال الطلب
          </button>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default Naqdi;
